var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('top-menu'),_c('v-main',[_c('router-view')],1),_c('warning-dialog',{on:{"closeWarningRefresh":_vm.onCloseWarningRefresh,"closeWarningSignOut":_vm.onCloseWarningSignOut}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }